module.exports = __webpack_public_path__ + "static/media/group_guide_img_2.ed43971e.png";